import { Phone, Envelope, MapPin, LinkedinLogo, FacebookLogo, InstagramLogo } from "@phosphor-icons/react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { href: "#services", label: "Services" },
    { href: "#tracking", label: "Track Repair" },
    { href: "#gallery", label: "Gallery" },
    { href: "#testimonials", label: "Testimonials" },
    { href: "#faq", label: "FAQ" },
    { href: "#contact", label: "Contact" },
  ];

  const services = [
    "Laser Repair",
    "Preventive Maintenance",
    "Equipment Sales",
    "Calibration",
    "Training",
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-sky-600 flex items-center justify-center">
                <span className="text-white font-black text-xl font-['Outfit']">L</span>
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold tracking-tight font-['Outfit'] leading-tight">
                  LASER DIVISION
                </span>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Expert cosmetic laser repair services for medical spas and
              dermatology clinics. Trusted by professionals nationwide.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-[#7A7D82] flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <LinkedinLogo weight="fill" className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-[#7A7D82] flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <FacebookLogo weight="fill" className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-800 hover:bg-[#7A7D82] flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <InstagramLogo weight="fill" className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-6">
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-slate-400">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-6">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+18016479206"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <Phone weight="fill" className="w-5 h-5 text-[#7A7D82]" />
                  (801) 647-9206
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@laserdivision.com"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <Envelope weight="fill" className="w-5 h-5 text-[#7A7D82]" />
                  info@laserdivision.com
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <MapPin weight="fill" className="w-5 h-5 text-[#7A7D82] flex-shrink-0 mt-0.5" />
                  <span>
                    2303 Ranch Rd Set 135
                    <br />
                    Lakeway, TX 78734
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
            <p>© {currentYear} John Laser Division. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
